import formatRelative, { parseDate } from '../../../utils/formatRelative';
import useBoardStore from '../../../store/boardStore';
import Tooltip from '../../common/Tooltip';

function initials(name) {
  return name ? name.split(' ').map((w) => w[0]).join('').toUpperCase().slice(0, 2) : '?';
}

// parseDate (não new Date(d) direto): created_at/updated_at do card passam
// pelo mesmo parsing tolerante a fuso ausente/presente de formatRelative.js.
function fmtCompact(d) {
  const dt = parseDate(d);
  if (!dt) return null;
  const day = dt.getDate();
  const month = dt.toLocaleDateString('pt-BR', { month: 'short' }).replace('.', '');
  const year = dt.getFullYear();
  return `${day} ${month}, ${year}`;
}

function fmtDate(d) {
  return fmtCompact(d) ?? '—';
}

function fmtFull(d) {
  const dt = parseDate(d);
  if (!dt) return null;
  const date = fmtCompact(d);
  const time = dt.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  return { date, time };
}

export default function CreatedCell({ card, mode = 'created' }) {
  const users = useBoardStore((s) => s.users);
  const userId = mode === 'created' ? card.created_by : card.updated_by;
  const when = mode === 'created' ? card.created_at : card.updated_at;
  const user = users.find((u) => u.id === userId);
  const label = mode === 'created' ? fmtDate(when) : (when ? formatRelative(when) : '—');
  const full = fmtFull(when);

  const tooltipContent = full ? (
    <div className="text-xs leading-relaxed">
      <div>{mode === 'created' ? 'Criado por' : 'Atualizado por'} <span className="font-medium">{user?.email || user?.name || '—'}</span></div>
      <div className="text-text-secondary">em {full.date} às {full.time}</div>
    </div>
  ) : null;

  return (
    <Tooltip content={tooltipContent} onlyWhenTruncated={false} delay={300}>
      <div className="cell-log w-full h-full flex items-center gap-2 min-h-[40px] cursor-default">
        {user && (
          <div className="w-6 h-6 rounded-full bg-accent/20 text-accent flex items-center justify-center text-[10px] font-semibold shrink-0">
            {user.avatar_url ? <img src={user.avatar_url} alt={user.name} className="w-full h-full rounded-full object-cover" /> : initials(user.name)}
          </div>
        )}
        <span className="text-text-primary truncate">{label}</span>
      </div>
    </Tooltip>
  );
}
